"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ShareButton_1 = __importDefault(require("../ShareButton"));
function createShareButton(networkName, link, optsMap, defaultProps) {
    function CreatedButton(props, ref) {
        return (react_1.default.createElement(ShareButton_1.default, __assign({}, defaultProps, props, { forwardedRef: ref, networkName: networkName, networkLink: link, opts: optsMap(props) })));
    }
    CreatedButton.displayName = "ShareButton-" + networkName;
    return react_1.forwardRef(CreatedButton);
}
exports.default = createShareButton;



//////////////////
// WEBPACK FOOTER
// ./~/react-share/lib/hocs/createShareButton.js
// module id = 44
// module chunks = 0